import request from "@/utils/request";

//素材列表
export function MenuServe(data) {
  return request({
    url: "/api/menu",
    method: "post",
    data,
  });
}